import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/Bookit-dark-logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-82484924")

_pushScopeId("data-v-82484924")
const _hoisted_1 = { class: "registration-container fadeInDown" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_5 = { class: "invalid-message" }
const _hoisted_6 = { class: "form-group position-relative" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_8 = { class: "invalid-message" }
const _hoisted_9 = {
  class: "form-text",
  style: {"color":"#adacb7"}
}
const _hoisted_10 = { class: "form-group position-relative" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_12 = { class: "invalid-message" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_15 = { class: "invalid-message" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_18 = { class: "invalid-message" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_21 = { class: "invalid-message" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_24 = { class: "invalid-message" }
const _hoisted_25 = {
  key: 0,
  class: "novalid-input"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_27 = {
  type: "submit",
  class: "bookit-button w-100 fs-18"
}
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "login-registration-logo mb-5"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_LanguageSwitcher),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h2", null, _toDisplayString(_ctx.$t('registration.welcome')), 1),
        _createVNode("h3", null, _toDisplayString(_ctx.$t('registration.aboutQuickSignUp')), 1)
      ]),
      _createVNode("form", {
        class: "registrationForm mx-auto",
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        novalidate: ""
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('registration.email')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.email = $event)),
            class: ["form-control form-control-lg", { invalid: _ctx.v$.email.$errors.length }],
            required: "",
            placeholder: _ctx.$t('registration.emailPlaceholder'),
            maxlength: "255"
          }, null, 10, ["placeholder"]), [
            [_vModelText, _ctx.form.email]
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
            return (_openBlock(), _createBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _hoisted_4,
              _createVNode("span", _hoisted_5, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('registration.password')), 1),
          _withDirectives(_createVNode("input", {
            type: _ctx.passwordFieldType,
            required: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.password = $event)),
            class: ["form-control form-control-lg pr-50", { invalid: _ctx.v$.password.$errors.length }],
            placeholder: "********",
            maxlength: "255"
          }, null, 10, ["type"]), [
            [_vModelDynamic, _ctx.form.password]
          ]),
          _createVNode("i", {
            class: ["icon-f fs-28 hide-show-pass", _ctx.passwordFieldType === 'password' ? 'icon-eye' : 'icon-eye-hide'],
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.passwordFieldType = _ctx.passwordFieldType === 'password' ? 'text' : 'password'))
          }, null, 2),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error) => {
            return (_openBlock(), _createBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _hoisted_7,
              _createVNode("span", _hoisted_8, _toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          _createVNode("small", _hoisted_9, _toDisplayString(_ctx.$t('registration.passwordRequirements')), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('registration.confirmPassword')), 1),
          _withDirectives(_createVNode("input", {
            type: _ctx.confirmPasswordFieldType,
            required: "",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.confirmPassword = $event)),
            class: ["form-control form-control-lg pr-50", { invalid: _ctx.v$.confirmPassword.$errors.length }],
            placeholder: "********",
            maxlength: "255"
          }, null, 10, ["type"]), [
            [_vModelDynamic, _ctx.form.confirmPassword]
          ]),
          _createVNode("i", {
            class: ["icon-f fs-28 hide-show-pass", _ctx.confirmPasswordFieldType === 'password' ? 'icon-eye' : 'icon-eye-hide'],
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmPasswordFieldType = _ctx.confirmPasswordFieldType === 'password' ? 'text' : 'password'))
          }, null, 2),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.confirmPassword.$errors, (error) => {
            return (_openBlock(), _createBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _hoisted_11,
              _createVNode("span", _hoisted_12, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('label.first-name')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            required: "",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.firstName = $event)),
            class: ["form-control form-control-lg", { invalid: _ctx.v$.firstName.$errors.length }],
            placeholder: _ctx.$t('registration.firstNamePlaceholder'),
            maxlength: "127"
          }, null, 10, ["placeholder"]), [
            [_vModelText, _ctx.form.firstName]
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.firstName.$errors, (error) => {
            return (_openBlock(), _createBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _hoisted_14,
              _createVNode("span", _hoisted_15, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('label.last-name')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            required: "",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.lastName = $event)),
            class: ["form-control form-control-lg", { invalid: _ctx.v$.lastName.$errors.length }],
            placeholder: _ctx.$t('registration.lastNamePlaceholder'),
            maxlength: "127"
          }, null, 10, ["placeholder"]), [
            [_vModelText, _ctx.form.lastName]
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.lastName.$errors, (error) => {
            return (_openBlock(), _createBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _hoisted_17,
              _createVNode("span", _hoisted_18, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('registration.companyName')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            required: "",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.companyName = $event)),
            class: ["form-control form-control-lg", { invalid: _ctx.v$.companyName.$errors.length }],
            placeholder: _ctx.$t('registration.companyNamePlaceholder'),
            maxlength: "255"
          }, null, 10, ["placeholder"]), [
            [_vModelText, _ctx.form.companyName]
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.companyName.$errors, (error) => {
            return (_openBlock(), _createBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _hoisted_20,
              _createVNode("span", _hoisted_21, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('registration.phoneNumber')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            required: "",
            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.mobileNumberChanged())),
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.phoneNumber = $event)),
            class: ["form-control form-control-lg mobile-input", { invalid: _ctx.v$.phoneNumber.$errors.length }],
            placeholder: "+123456789",
            maxlength: "255"
          }, null, 34), [
            [_vModelText, _ctx.form.phoneNumber]
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.v$.phoneNumber.$errors, (error) => {
            return (_openBlock(), _createBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _hoisted_23,
              _createVNode("span", _hoisted_24, _toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          (_ctx.incorrectMobile)
            ? (_openBlock(), _createBlock("div", _hoisted_25, [
                _hoisted_26,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('novalid.input.mobile')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("button", _hoisted_27, _toDisplayString(_ctx.$t('registration.openFreeAccount')), 1)
      ], 32),
      _createVNode("div", _hoisted_28, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withId(() => [
            _hoisted_29
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
})